// 导入 抽取的 请求对象
import ajaxRequest from '../utils/request';
const reFix = 'productadmin';
// 抽取的接口方法
// 获取列表
export function bannerList(params) {
  return ajaxRequest({
    url: reFix + '/Ad/Get',
    method: 'GET',
    params: { ...params },
  });
}
// 获取单个广告
export function bannerGetModel(id) {
  return ajaxRequest({
    url: reFix + '/Ad/ad' + id,
    method: 'GET',
  });
}

// 添加广告
export function bannerAdd(data) {
  return ajaxRequest({
    url: reFix + '/Ad/ad',
    method: 'POST',
    data,
  });
}

// 删除广告
export function bannerRemove(data) {
  return ajaxRequest({
    url: reFix + '/Ad',
    method: 'DELETE',
    data,
  });
}
// 更新广告
export function bannerEdit(id, data) {
  return ajaxRequest({
    url: reFix + '/Ad/ad/' + id,
    method: 'PUT',
    data,
  });
}

// 设置广告
export function bannerChange(type, data) {
  return ajaxRequest({
    url: reFix + '/Ad/ad/' + type,
    method: 'PUT',
    data,
  });
}

// 上传图片 文件上传
export function bannerUpload(data) {
  return ajaxRequest({
    url: 'upload/images/photo',
    method: 'POST',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
// 上传图片,base64上传
export function pictureUpload(data) {
  return ajaxRequest({
    url: 'upload/images/upload',
    method: 'POST',
    data,
    // headers: { 'Content-Type': 'multipart/form-data' },
  });
}

// 获取广告位
export function positionList(params) {
  return ajaxRequest({
    url: reFix + '/Ad/position',
    method: 'GET',
    params,
  });
}

// 添加广告位
export function positionAdd(data) {
  return ajaxRequest({
    url: reFix + '/Ad/position',
    method: 'POST',
    data,
  });
}

// 删除广告位
export function positionRemove(data) {
  return ajaxRequest({
    url: reFix + '/Ad/position',
    method: 'DELETE',
    data,
  });
}
// 更新广告
export function positionEdit(id, data) {
  return ajaxRequest({
    url: reFix + '/Ad/position/' + id,
    method: 'PUT',
    data,
  });
}
// 广告管理-->新增-->跳转设置 下拉列表-楼盘动态
export function houseNewsApi(areaId) {
  return ajaxRequest({
    url: reFix + '/Ad/houseNews/' + areaId,
    method: 'GET',
  });
}
